const UserPreferenceWidgetIcon = ({ isOpen }) => {
  const basePath = `${window.location.origin}/images`;
  return (
    <img
      src={
          `${basePath}/userpreference-icon.svg`
      }
      alt="User Preference Widget"
      style={{ width: 16, height: 16 , border : '2px solid white', marginBottom: 1.3}}
    />
  );
};

export default UserPreferenceWidgetIcon;
